<template>
  <ul class="nav nav-pills nav-stacked">
    <li class="active">
      <a href="#"> <i class="fa fa-user"></i> News feed</a>
    </li>
    <li>
      <a href="#">
        <i class="fa fa-envelope"></i> Messages
        <span class="label label-info pull-right r-activity">9</span>
      </a>
    </li>
  </ul>
</template>